/* eslint-disable @typescript-eslint/no-explicit-any */
import pipe from './pipe';
import sanitize from './sanitize';

export default pipe(sanitize, (params: any) =>
  new URLSearchParams(params).toString()
);
